module.exports = __webpack_public_path__ + "img/profile-f.2a8d4454.svg";